export default __webpack_public_path__ + "static/media/dentist_transparent.4a114550.png";